export default __webpack_public_path__ + "static/media/Ar Condicionado.a60aca2a.svg";